<template>

  <div id="app">
    <v-app>
    <v-content>
    <Navigation/>
    <router-view/>
    </v-content>
   </v-app>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'App',
  components: {
    Navigation,
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue